import React from "react";
import PlayerItem from "./PlayerItem";
import { IPlayerSearchResponse } from "../../../types/IPlayerSearchResponse";
import CustomList from "../../../ui/CustomList";
import { IPlayerComparisonData } from "../../../types/IPlayerComparison";

interface ISearchPlayerProps {
  searchData: any[];
  searchText: string;
  onSelect?: (item: IPlayerSearchResponse | IPlayerSearchResponse[] | null, selected: boolean) => void;
  selectedItems: IPlayerSearchResponse[];
  multiSelection?: boolean;
  iconType: string;
  displayCheckBox?: boolean;
  isMaxWidth?: boolean;
  isForComparePlayerASrchtype? : boolean;
  isForSimulation? : boolean;
  onAddToShortlist?: (player: IPlayerSearchResponse) => void;
  playerComparisonTableData?:IPlayerComparisonData[]
}

const PlayerSearchList: React.FC<ISearchPlayerProps> = ({
  searchData,
  searchText,
  onSelect,
  selectedItems,
  multiSelection,
  iconType,
  displayCheckBox,
  isMaxWidth = true,
  isForComparePlayerASrchtype,
  isForSimulation,
  onAddToShortlist,
  playerComparisonTableData
}) => {
  return (
    <CustomList<IPlayerSearchResponse>
      selectedItems={selectedItems}
      onSelect={onSelect}
      multiSelection={multiSelection}
      isCheckBox={displayCheckBox}
      showSelectAllCheckbox={false}
      isMaxWidth={isMaxWidth}
      isFromSimulation={true}
    >
      {searchData.map((player) => (
        <PlayerItem key={player.playerId} item={player} searchText={searchText} iconType={iconType}
        isForComparePlayerASrchtype={isForComparePlayerASrchtype}
        isForSimulation={isForSimulation}
        onAddToShortlist={onAddToShortlist}
        playerComparisonTableData={playerComparisonTableData}
        />
      ))}
    </CustomList>
  );
};

export default PlayerSearchList;
